import React from 'react';

import { useFieldArray, useFormContext, get } from 'react-hook-form';
import type { Validate } from 'react-hook-form';

import { getFormError } from 'constants/formErrors';

import { BasicInput } from '../BasicInput';
import { DetailList, DetailListRemoveButton } from './DetailList';

export const DetailFormArrayValue = ({
    disabled,
    name,
    label,
    validateValueFunction,
}: {
    disabled?: boolean;
    name: string;
    label?: string;
    validateValueFunction?: Validate<string, object>;
}) => {
    const {
        register,
        formState: { errors },
    } = useFormContext();
    const { fields, append, remove } = useFieldArray({ name });

    const errorObject = get(errors, name || '');
    const error = errorObject ? getFormError(errorObject.type, errorObject.message) : '';

    return (
        <>
            {error ? <div className="text-sm text-destructive">{error}</div> : null}
            <DetailList
                label={label}
                onAdd={disabled ? undefined : () => append({})}
                items={fields.map((item, index) => {
                    const itemErrorObject = get(errors, `${name}.${index}.value`);
                    const itemError = itemErrorObject
                        ? getFormError(itemErrorObject.type, itemErrorObject.message)
                        : '';

                    return (
                        <React.Fragment key={item.id}>
                            <BasicInput
                                disabled={disabled}
                                {...register(`${name}.${index}.value`, {
                                    validate: validateValueFunction
                                        ? {
                                              value: validateValueFunction,
                                          }
                                        : undefined,
                                })}
                            />
                            {itemError ? <div className="text-sm text-destructive">{itemError}</div> : null}
                            <DetailListRemoveButton disabled={disabled} onClick={() => remove(index)} />
                        </React.Fragment>
                    );
                })}
            />
        </>
    );
};
